import React from "react";
import Navbar from "../../components/navigation/Navbar";
import { useTranslation } from "react-i18next";
import { ContextProvider } from "../../components/table/timecard/Context";
import { Table } from "../../components/table/timecard/TableSingle";

const Timecard = () => {
	const { t } = useTranslation('timecard.page');

	return (
		<>
			<Navbar
				view={{
					title: t("title"),
					component: (
						<ContextProvider>
							<Table />
						</ContextProvider>
					),
				}}
				right={{
					title: t("title"),
					component: <> componente </>,
				}}
			/>
		</>
	);
};

export { Timecard };
